import React from 'react';
import {store} from "../../product-page/store/store";
import { Provider} from "react-redux";
import { createRoot } from 'react-dom/client';
import ProductPage from "../../product-page/product-page";
import './product-page.scss';

const htmlElement = document.getElementById("product-app")
const root = createRoot(htmlElement as HTMLElement);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <ProductPage apiUrl={htmlElement.dataset.apiurl}
                         galleryApiUrl={htmlElement.dataset.galleryapiurl}
                         specificationApiUrl={htmlElement.dataset.specificationapiurl}
                         productName={htmlElement.dataset.productname}
                         regionCode={htmlElement.dataset.regioncode}
                         previewToken={htmlElement.dataset.previewtoken}
                         previewDate={htmlElement.dataset.previewdate}
                // instructions={htmlElement.dataset.instructions}
                // searchText={htmlElement.dataset.searchtext}
                // resetText={htmlElement.dataset.resettext}
                // submitText={htmlElement.dataset.submittext}
                // recaptchaSiteKey={htmlElement.dataset.recaptchasitekey}
                // recaptchaLanguage={htmlElement.dataset.recaptchalanguage}
                // recaptchaRequiredMessage={htmlElement.dataset.recaptcharequiredmessage}
            />
        </Provider>
    </React.StrictMode>,
    htmlElement
);